
export { Order, Label };

// 订单
class Order {
    constructor() {
        this.id = "M";
        this.orderType = "A";
        this.type = ""; //C
        this.deliveryTime = "";
        this.quantity = 1;
        this.paperElementD = 76;
        this.printInfo = "无";
        this.compare = "N";
        this.color = "S";
        this.roll = "O";
        this.packing = "常规";
        this.numberOfRoll = 1;
        this.rollOfPacking = "常规";
        this.remark = "";
        this.haveAttachment = false;
        this.orientation = "N";
        this.salesman = "";
        this.UL = false;
        this.paperElementM = "";
        this.createTime = "";
    }
}

// 标签
class Label {
    constructor() {
        this.material = "";
        this.lbLength = 0;
        this.lbWidth = 0;
        this.angle = 1.5;
        this.dashed = false;
        this.cut = false;
        this.hole = 0;
        this.vSpacing = 2;
        this.hSpacing = 0;
        this.leftBorderMin = 1;
        this.leftBorderMax = 2;
        this.rightBorderMin = 1;
        this.rightBorderMax = 2;
        this.row = 1;
        this.customer = "";
        this.black = "";
        this.customerMaterial = "";
    }
}


// WEBPACK FOOTER //
// ./src/models/production.js